const checkLenDate = (num: number) => {
  return num < 10 ? `0${num}` : num
}

export const fixDate = (date: Date) => {
  return `${date.getFullYear()}-${checkLenDate(date.getMonth() + 1)}-${checkLenDate(date.getDate())}T${checkLenDate(date.getHours())}:${checkLenDate(date.getMinutes())}:00`
}